"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCKED_MODEL_POLE_FIELDS = void 0;
// core-model-pole src/map/collection.polefield.ts
exports.LOCKED_MODEL_POLE_FIELDS = {
    poleNumber: true,
    poleID: true,
    images: true,
    poleType: true,
    poleOwner: true,
    circumference: true,
    agl: true,
    geographicCoordinate: true,
    trueSizeCapture: true,
    span: true,
    spanType: true,
    spanLength: true,
    spanEnvironment: true,
    spanMidSpanPhoto: true,
    spanNote: true,
    circuit: true,
    circuitConstruction: true,
    circuitMidSpanHeight: true,
    wire: true,
    wireOwner: true,
    wireInsulator: true,
    wireAttachmentHeight: true,
    wireSize: true,
    wireQuantity: true,
    anchor: true,
    anchorType: true,
    anchorOwner: true,
    anchorLeadLength: true,
    anchorNote: true,
    guys: true,
    guySize: true,
    guyOwner: true,
    guyAttachmentHeight: true,
    equipment: true,
    equipmentType: true,
    equipmentAttachmentHeight: true,
    equipmentBottomHeight: true,
    equipmentOrientation: true,
    equipmentQuantity: true,
    equipmentOwner: true,
    equipmentNote: true,
    spanGuys: true,
    spanGuySize: true,
    spanGuyOwner: true,
    spanGuyAttachmentHeight: true,
    spanGuyMidSpanHeight: true,
    spanGuyHeightAtWEP: true,
    spanGuyType: true,
    pls_poleId: true,
    pls_poleLocation: true,
    pls_poleSubForm: true,
    pls_poleNumber: true,
    pls_multiPoleVector: true,
    pls_poleTagPhotos: true,
    pls_poleIkePhotos: true,
    pls_poleType: true,
    pls_agl: true,
    pls_groundLineCircumference: true,
    pls_anchorSubForm: true,
    pls_anchorLeadLength: true,
    pls_anchorType: true,
    pls_guySubForm: true,
    pls_downGuySize: true,
    pls_guyAttachmentHeight: true,
    pls_guyStrainInsulator: true,
    pls_guyStrainInsulatorAttachmentHeight: true,
    pls_equipmentAzimuth: true,
    pls_equipmentType: true,
    pls_equipmentHeight: true,
    pls_equipmentSubForm: true,
    pls_cableOtherPoleNumber: true,
    pls_spanGuySize: true,
    pls_spanGuyThisAttachmentHeight: true,
    pls_spanGuyOtherAttachmentHeight: true,
    pls_cableSubForm: true,
    pls_jointHeight: true,
    pls_jointName: true,
    pls_jointSubForm: true,
    pls_spanAlignment: true,
    pls_spanPoleNumber: true,
    pls_spanType: true,
    pls_spanVector: true,
    pls_wireSurveySubForm: true,
    pls_wireSurveyGroundShot: true,
    pls_wireSurveyWireSubForm: true,
    pls_wireSurveyWireHeight: true,
    pls_wireSurveyWireDescription: true,
    pls_framingSubForm: true,
    pls_framingType: true,
    pls_framingLocationSubForm: true,
    pls_framingHeight: true,
    pls_armSubForm: true,
    pls_armWireType: true,
    pls_armType: true,
    pls_armInsulatorType: true,
    pls_armTerminalDeadEnd: true,
    pls_numberOfWires: true,
    pls_wireLayout: true,
    pls_armLocationSubForm: true,
    pls_armHeight: true,
    pls_insulatorSubForm: true,
    pls_insulatorWireType: true,
    pls_insulatorType: true,
    pls_postInsulatorSide: true,
    pls_insulatorTerminalDeadEnd: true,
    pls_insulatorLocationSubForm: true,
    pls_insulatorHeight: true,
    pls_spanSubForm: true,
    pls_tapSubForm: true,
    pls_tapLocation: true,
    pls_tapHeight: true,
    pls_tapWireType: true,
    pls_tapPoleNumber: true,
    pls_tapPoleAttachmentHeight: true,
    pls_tapInsulatorType: true,
    pls_surveyPointSubForm: true,
    pls_surveyPointLocation: true,
    pls_surveyPointDescription: true,
    pls_notes: true,
    // IKE PoleForeman Fields
    ipf_id: true,
    ipf_tagPhotos: true,
    ipf_type: true,
    ipf_tip: true,
    ipf_location: true,
    ipf_ikePhoto: true,
    ipf_equipment: true,
    ipf_equipmentType: true,
    ipf_equipmentOrientation: true,
    ipf_equipmentAttachmentHeight: true,
    ipf_equipmentNote: true,
    ipf_anchor: true,
    ipf_anchorAssembly: true,
    ipf_anchorLeadLength: true,
    ipf_anchorNote: true,
    ipf_anchorGuys: true,
    ipf_anchorGuySize: true,
    ipf_anchorGuyAttachmentHeight: true,
    ipf_anchorGuyStrutHeight: true,
    ipf_span: true,
    ipf_spanLength: true,
    ipf_spanType: true,
    ipf_spanMidSpanIkePhoto: true,
    ipf_spanNote: true,
    ipf_spanPowerCircuit: true,
    ipf_spanPowerCircuitType: true,
    ipf_spanPowerCircuitPrimaryConductor: true,
    ipf_spanPowerCircuitPrimaryFraming: true,
    ipf_spanPowerCircuitPrimaryPhaseAHeight: true,
    ipf_spanPowerCircuitPrimaryPhaseBHeight: true,
    ipf_spanPowerCircuitPrimaryPhaseCHeight: true,
    ipf_spanPowerCircuitNeutralConductor: true,
    ipf_spanPowerCircuitNeutralFraming: true,
    ipf_spanPowerCircuitNeutralHeight: true,
    ipf_spanPowerCircuitSecondaryConductor: true,
    ipf_spanPowerCircuitSecondaryFraming: true,
    ipf_spanPowerCircuitSecondaryPhaseAHeight: true,
    ipf_spanPowerCircuitSecondaryPhaseBHeight: true,
    ipf_spanPowerCircuitSecondaryPhaseCHeight: true,
    ipf_spanPowerCircuitShieldWireConductor: true,
    ipf_spanPowerCircuitShieldWireFraming: true,
    ipf_spanPowerCircuitShieldWireHeight: true,
    ipf_spanCircuitSpacer: true,
    ipf_spanCircuitSpacerMessenger: true,
    ipf_spanCircuitSpacerPhaseSize: true,
    ipf_spanCircuitSpacerSpacerFraming: true,
    ipf_spanCircuitSpacerSpacerAttachmentHeight: true,
    ipf_spanCircuitSpacerNeutralConductor: true,
    ipf_spanCircuitSpacerNeutralFraming: true,
    ipf_spanCircuitSpacerNeutralHeight: true,
    ipf_spanCircuitSpacerSecondaryConductor: true,
    ipf_spanCircuitSpacerSecondaryFraming: true,
    ipf_spanCircuitSpacerSecondaryPhaseAHeight: true,
    ipf_spanCircuitSpacerSecondaryPhaseBHeight: true,
    ipf_spanCircuitSpacerSecondaryPhaseCHeight: true,
    ipf_spanCircuitAerial: true,
    ipf_spanCircuitAerialCable: true,
    ipf_spanCircuitAerialAerialFraming: true,
    ipf_spanCircuitAerialAerialAttachmentHeight: true,
    ipf_spanCircuitAerialNeutralConductor: true,
    ipf_spanCircuitAerialNeutralFraming: true,
    ipf_spanCircuitAerialNeutralHeight: true,
    ipf_spanCircuitAerialSecondaryConductor: true,
    ipf_spanCircuitAerialSecondaryFraming: true,
    ipf_spanCircuitAerialSecondaryPhaseAHeight: true,
    ipf_spanCircuitAerialSecondaryPhaseBHeight: true,
    ipf_spanCircuitAerialSecondaryPhaseCHeight: true,
    ipf_spanCircuitFosc: true,
    ipf_spanCircuitFoscSize: true,
    ipf_spanCircuitFoscFraming: true,
    ipf_spanCircuitFoscHeight: true,
    ipf_spanCommunication: true,
    ipf_spanCommunicationMidSpanHeight: true,
    ipf_spanCommunicationSize: true,
    ipf_spanCommunicationHorizOffset: true,
    ipf_spanCommunicationAttachmentHeight: true,
    ipf_spanGuy: true,
    ipf_spanGuySize: true,
    ipf_spanGuyInsulator: true,
    ipf_spanGuyAttachmentHeight: true,
    ipf_services: true,
    ipf_serviceLength: true,
    ipf_servicePower: true,
    ipf_servicePowerMidSpanHeight: true,
    ipf_servicePowerConductor: true,
    ipf_servicePowerHeight: true,
    ipf_serviceEndpointHeight: true,
    ipf_serviceCommunications: true,
    ipf_serviceCommunicationsMidSpanHeight: true,
    ipf_serviceCommunicationsCable: true,
    ipf_serviceCommunicationsHeight: true,
    ipf_serviceCommunicationsEndpointHeight: true
};
//# sourceMappingURL=form.field.lock.js.map